/**
 * TYPO3 Form Framework: nach Server-Validierung Fokus auf erstes fehlerhaftes Feld,
 * aria-invalid / aria-describedby mit Fehlercontainer verknüpfen.
 */
(function () {
  'use strict';

  function findFirstControlInRow(row) {
    var controls = row.querySelectorAll(
      'input:not([type="hidden"]):not([type="button"]):not([type="submit"]):not([type="reset"]), select, textarea'
    );
    for (var i = 0; i < controls.length; i++) {
      var el = controls[i];
      if (el.disabled) {
        continue;
      }
      return el;
    }
    var cb = row.querySelector('input[type="checkbox"], input[type="radio"]');
    if (cb && !cb.disabled) {
      return cb;
    }
    return null;
  }

  function linkAriaToError(row) {
    var errorEl = row.querySelector('.form__row__error');
    if (!errorEl || !errorEl.id) {
      return;
    }
    var errorId = errorEl.id;
    var control = findFirstControlInRow(row);
    if (!control) {
      return;
    }
    control.setAttribute('aria-invalid', 'true');
    var existing = control.getAttribute('aria-describedby');
    if (existing) {
      var parts = existing.split(/\s+/).filter(Boolean);
      if (parts.indexOf(errorId) === -1) {
        parts.push(errorId);
      }
      control.setAttribute('aria-describedby', parts.join(' '));
    } else {
      control.setAttribute('aria-describedby', errorId);
    }
  }

  function focusFirstInvalidField() {
    var rows = document.querySelectorAll('form .form__row.has-error');
    if (!rows.length) {
      return;
    }

    rows.forEach(function (row) {
      linkAriaToError(row);
    });

    var firstRow = rows[0];
    var target = findFirstControlInRow(firstRow);
    if (!target) {
      return;
    }

    window.requestAnimationFrame(function () {
      try {
        target.focus({ preventScroll: false });
      } catch (e) {
        target.focus();
      }
      try {
        target.scrollIntoView({ block: 'center', behavior: 'smooth' });
      } catch (e2) {
        target.scrollIntoView(true);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusFirstInvalidField);
  } else {
    focusFirstInvalidField();
  }
})();
